import { Component, OnInit } from '@angular/core';
import { ChartOptions, ChartType, ChartDataset } from 'chart.js';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AnalyticsService } from 'src/app/services/analytics.service';
import * as CryptoJS from 'crypto-js';

@Component({
  selector: 'app-analytics-dummy-data',
  templateUrl: './analytics-dummy-data.component.html',
  styleUrls: ['./analytics-dummy-data.component.scss']
})
export class AnalyticsDummyDataComponent implements OnInit {

  selectedTimeframeLine: string = 'last-7-days';
  selectedTimeframeBar: string = 'last-7-days';
  allStories: any[] = [];

  chartType: ChartType = 'line';

  chartData: ChartDataset<'line'>[] = [{
    data: [],
    label: '',
    backgroundColor: 'rgba(50, 206, 255, 0.5)',
    borderColor: 'rgba(50, 206, 255, 1)',

  }];
  chartLabels: string[] = [];
  chartOptions: ChartOptions = {
    responsive: true,
    scales: {
      x: {
        title: {
          display: true,
          text: 'Time'
        }
      },
      y: {
        beginAtZero: true,
        ticks: {
          precision: 0,
        },
        title: {
          display: false,
          text: ''
        }
      }
    },
  };

  eventCount!: string;
  totalUsers!: string;
  eventCountBar!: string;
  totalUsersBar!: string;
  printTimeframeValues(): void {
    switch (this.selectedTimeframeLine) {
      case 'last-7-days':
        this.eventCount = '62'
        this.totalUsers = '28'
        break;
      case 'last-30-days':
        this.eventCount = '288'
        this.totalUsers = '118'
        break;
      case 'last-12-months':
        this.eventCount = '4514'
        this.totalUsers = '1389'
        break;
    }

    switch (this.selectedTimeframeBar) {
      case 'last-7-days':
        this.eventCountBar = '48'
        this.totalUsersBar = '18'
        break;
      case 'last-30-days':
        this.eventCountBar = '181'
        this.totalUsersBar = '72'
        break;
      case 'last-12-months':
        this.eventCountBar = '2188'
        this.totalUsersBar = '1122'
        break;
    }
  }

  // Define chartType for the bar chart
  barChartType: ChartType = 'bar';

  // Bar chart data and options
  barChartData: ChartDataset<'bar'>[] = [{
    data: [],
    label: '',
    backgroundColor: 'rgba(50, 206, 255, 1)',
    borderColor: 'rgba(50, 206, 255, 1)',
    borderRadius: 16
  }];
  barChartLabels: string[] = [];
  barChartOptions: ChartOptions = {
    responsive: true,
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          stepSize: 1
        },
      }
    }
  };

  constructor(
    private firestore: AngularFirestore,
    private afAuth: AngularFireAuth,
    private http: HttpClient,
    private analytics: AnalyticsService,
  ) { }

  ngOnInit(): void {
    this.updateChart();
    this.updateBarChart();
  }

  updateChart(): void {
    switch (this.selectedTimeframeLine) {
      case 'last-7-days':
        this.chartLabels = this.get7DaysLabels();
        this.chartData[0].data = this.get7DaysStoryOpenedData();
        break;
      case 'last-30-days':
        this.chartLabels = this.get30DaysLabels();
        this.chartData[0].data = this.get30DaysStoryOpenedData();
        break;
      case 'last-12-months':
        this.chartLabels = this.getMonthsLabels();
        this.chartData[0].data = this.getLast12MonthsStoryOpenedData();
        break;
    }
    this.printTimeframeValues();
  }

  updateBarChart(): void {
    switch (this.selectedTimeframeBar) {
      case 'last-7-days':
        this.barChartLabels = this.get7DaysLabels();
        this.barChartData[0].data = this.get7DaysButtonTapsData();
        break;
      case 'last-30-days':
        this.barChartLabels = this.get30DaysLabels();
        this.barChartData[0].data = this.get30DaysButtonTapsData();
        break;
      case 'last-12-months':
        this.barChartLabels = this.getMonthsLabels();
        this.barChartData[0].data = this.get12MonthsButtonTapsData();
        break;
    }
    this.printTimeframeValues();
  }

  // Sample button taps data for different timeframes


  get7DaysStoryOpenedData(): number[] {
    return [7, 6, 15, 14, 13, 2, 4];
  }

  get30DaysStoryOpenedData(): number[] {
    return [2, 10, 9, 22, 3, 13, 15, 3, 8, 6, 18, 11, 9, 3, 8, 7, 10, 12, 22, 3, 18, 12, 3, 7, 6, 15, 14, 13, 2, 4];
  }

  getLast12MonthsStoryOpenedData(): number[] {
    return [280, 398, 443, 389, 423, 407, 319, 400, 351, 381, 335, 388];
  }

  // case 'last-7-days':
  //   this.eventCountBar = '48'
  //   this.totalUsersBar = '18'
  //   break;
  // case 'last-30-days':
  //   this.eventCountBar = '181'
  //   this.totalUsersBar = '72'
  //   break;
  // case 'last-12-months':
  //   this.eventCountBar = '2188'
  //   this.totalUsersBar = '1122'
  //   break;
  get7DaysButtonTapsData(): number[] {
    return [5, 4, 11, 9, 13, 1, 3];
  }

  get30DaysButtonTapsData(): number[] {
    return [2, 5, 9, 8, 3, 13, 2, 3, 8, 6, 8, 1, 9, 3, 8, 7, 10, 5, 3, 3, 9, 12, 3, 7, 6, 1, 14, 9, 2, 2];
  }

  get12MonthsButtonTapsData(): number[] {
    return [80, 198, 143, 389, 223, 107, 119, 107, 297, 301, 135, 188];
  }

  get7DaysLabels(): string[] {
    return ['Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun', 'Mon'];
  }

  get30DaysLabels(): string[] {
    return ['30 Dec', '01 Jan', '02 Jan', '03 Jan', '04 Jan', '05 Jan', '06 Jan', '07 Jan', '08 Jan', '09 Jan', '10 Jan', '11 Jan', '12 Jan', '13 Jan', '14 Jan', '15 Jan', '16 Jan', '17 Jan', '18 Jan', '18 Jan', '19 Jan', '20 Jan', '21 Jan', '22 Jan', '23 Jan', '24 Jan', '25 Jan', '26 Jan', '27 Jan', '28 Jan'];
  }

  getMonthsLabels(): string[] {
    return ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  }

}
